import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "self-stretch flex-col justify-start items-start gap-5 md:gap-3 flex" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 2,
  class: "w-[28px]"
}

import { IReviewSummary, IReviewSummaryItem } from '@/interfaces';
import SummaryListItem from './SummaryListItem.vue';
import { useFormStore } from '@/store';
import { Link } from '@sitecore-jss/sitecore-jss-vue';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';


export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryList',
  props: {
    reviewSummary: {}
  },
  emits: ["editClicked"],
  setup(__props: any, { emit: __emit }) {

const formStore = useFormStore();



// Exposed to track which "edit" link was clicked from the ReviewSummary
const emit = __emit;
function onEditDetails(goToStep: number, reviewSummary: IReviewSummary, reviewSummaryItem: IReviewSummaryItem) {
  emit('editClicked', reviewSummary, reviewSummaryItem);
  formStore.goToStep(goToStep);
}

function formatLink(url: string): LinkField {
  return {
    value: {
      href: url,
      target: '_self',
    },
  };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewSummary.items, (item, itemIndex) => {
      return (_openBlock(), _createBlock(SummaryListItem, {
        key: itemIndex,
        item: item,
        isLastReviewSummaryItem: itemIndex === _ctx.reviewSummary.items.length - 1
      }, {
        edit: _withCtx(() => [
          (item.editUrl && item.showEdit)
            ? (_openBlock(), _createBlock(_unref(Link), {
                key: 0,
                field: formatLink(item.editUrl),
                class: "text-base-bold"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Edit")
                ])),
                _: 2
              }, 1032, ["field"]))
            : _createCommentVNode("", true),
          (item.editGoToStep != null && item.showEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "link text-base-bold",
                onClick: ($event: any) => (onEditDetails(item.editGoToStep, _ctx.reviewSummary, item))
              }, " Edit ", 8, _hoisted_2))
            : _createCommentVNode("", true),
          (itemIndex === _ctx.reviewSummary.items.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["item", "isLastReviewSummaryItem"]))
    }), 128))
  ]))
}
}

})